module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/exchange/exchange.component.scss
// module id = ./src/app/pages/exchange/exchange.component.scss
// module chunks = main